import type {AxiosRequestConfig} from 'axios';
import {Driver} from './interface';

export class DeleteDriverBuilder {
  private readonly driversRequest: AxiosRequestConfig = {
    method: 'DELETE',
    url: '',
  };
  id(id: number) {
    this.driversRequest.url = `/drivers/${id}`;
    return this;
  }
  build() {
    return this.driversRequest;
  }
}
export class GetAllDriversRequestBuilder {
  private readonly driversRequest: AxiosRequestConfig = {
    method: 'GET',
    url: '/drivers',
    params: {},
  };

  id(id: number) {
    this.driversRequest.url = `/drivers/${id}`;
    return this;
  }

  params(params: object) {
    this.driversRequest.params = params;
    return this;
  }

  build() {
    return this.driversRequest;
  }
}

export class GetDriversWalletsRequestBuilder {
  private readonly driversRequest: AxiosRequestConfig = {
    method: 'GET',
    url: '/drivers/wallets',
    params: {},
  };

  id(id: number) {
    this.driversRequest.url = `/drivers/wallets/${id}`;
    return this;
  }

  params(params: object) {
    this.driversRequest.params = params;
    return this;
  }

  build() {
    return this.driversRequest;
  }
}

export class GetDriversCountRequestBuilder {
  private readonly driversRequest: AxiosRequestConfig = {
    method: 'GET',
    url: '/drivers/count',
  };

  params(params: object) {
    this.driversRequest.params = params;
    return this;
  }

  build() {
    return this.driversRequest;
  }
}

export class GetDriverWalletTransactionCountRequestBuilder {
  private readonly driversRequest: AxiosRequestConfig = {
    method: 'GET',
    url: '',
  };

  id(id: number) {
    this.driversRequest.url = `drivers/${id}/transactions/count`;
    return this;
  }

  params(params: object) {
    this.driversRequest.params = params;
    return this;
  }

  build() {
    return this.driversRequest;
  }
}

export class GetDriversSumWalletsRequestBuilder {
  private readonly driversRequest: AxiosRequestConfig = {
    method: 'GET',
    url: '/drivers/wallets/sum',
  };

  params(params: object) {
    this.driversRequest.params = params;
    return this;
  }

  build() {
    return this.driversRequest;
  }
}

export class AddDriverWalletBulkTransactionRequestBuilder {
  private readonly driversRequest: AxiosRequestConfig = {
    method: 'POST',
    url: '/drivers/transactions/batch',
  };

  data(data: object) {
    this.driversRequest.data = data;
    return this;
  }

  build() {
    this.driversRequest.headers = {
      'Content-Type': 'multipart/form-data'
    };
    return this.driversRequest;
  }
}

export class CreateDriverRequestBuilder {
  private readonly driversRequest: AxiosRequestConfig = {
    method: 'POST',
    url: '/drivers',
    data: {},
  };

  data(data: Driver) {
    this.driversRequest.data = data;
    return this;
  }

  build() {
    return this.driversRequest;
  }
}

export class AddDriverWalletTransactionRequestBuilder {
  private readonly driversRequest: AxiosRequestConfig = {
    method: 'POST',
    url: '',
    data: {},
  };

  id(id: number) {
    this.driversRequest.url = `drivers/${id}/transactions`;
    return this;
  }

  data(data: Driver) {
    this.driversRequest.data = data;
    return this;
  }

  build() {
    return this.driversRequest;
  }
}

export class GetDriverWalletTransactionRequestBuilder {
  private readonly driversRequest: AxiosRequestConfig = {
    method: 'GET',
    url: '',
    data: {},
  };

  id(id: number) {
    this.driversRequest.url = `drivers/${id}/transactions`;
    return this;
  }

  params(params: Object) {
    this.driversRequest.params = params;
    return this;
  }

  build() {
    return this.driversRequest;
  }
}

export class DriverStreamLiveLocationRequestBuilder {
  private readonly driversRequest: AxiosRequestConfig = {
    method: 'POST',
    url: '/drivers',
    data: {},
  };

  id(id: number) {
    this.driversRequest.url = `/drivers/${id}/stream-live-location`;
    return this;
  }

  data(data: Driver) {
    this.driversRequest.data = data;
    return this;
  }

  build() {
    return this.driversRequest;
  }
}

export class UpdateDriverRequestBuilder {
  private readonly driversRequest: AxiosRequestConfig = {
    method: 'PUT',
    url: '/drivers',
    data: {},
  };
  data(body: Driver) {
    this.driversRequest.data = body;
    return this;
  }
  build() {
    return this.driversRequest;
  }
}

export class UpdateDriverStatusRequestBuilder {
  private readonly driversRequest: AxiosRequestConfig = {
    method: 'PUT',
    url: '/drivers',
    data: {},
  };
  id(id: number) {
    this.driversRequest.url = `/drivers/${id}/status`;
    return this;
  }
  data(body: Driver) {
    this.driversRequest.data = body;
    return this;
  }
  build() {
    return this.driversRequest;
  }
}
